import { useEffect, useRef, useState } from 'react'
import GalleryHeaderText from '../components/molecules/gallery-header-text'
import GalleryReveal from '../components/organisms/gallery-reveal'
import { usePageTheme } from '../hooks/pageThemeHook'
import Layout from '../layouts/layout'

import { CSSTransition } from 'react-transition-group'
import Gallery from '../components/organisms/gallery-page/gallery'
import FilmStrip from '../components/organisms/film-strip'

const GalleryPage = () => {
	const { setDarkTheme } = usePageTheme()

	useEffect(() => {
		setDarkTheme(true)
	}, [setDarkTheme])

	return (
		<Layout>
			<GalleryHeaderText />
			<GalleryReveal />
			<Gallery />
			<FilmStrip />
		</Layout>
	)
}

export default GalleryPage
